import * as React from "react";
import { useNavigate, useLocation } from "react-router-dom";

import QuestionRenderer from "./components/QuestionRenderer";
import { getQuestionDetails } from "../../../utils/question";
import { useSelector } from "../../../store/";

import LoadingIndicator from "../../../components/ui-components/LoadingIndicator";

export default function Questions() {
	const location = useLocation();
	const navigate = useNavigate();

	const question = useSelector((state) => state.question);

	const learner = useSelector((state) => state.learner || {});
	const publicUrl = process.env.PUBLIC_URL;
	const [loading] = React.useState(false);

	const [questionId, setQuestionId] = React.useState(
		learner?.details?.state?.currentQuestion || []
	);

	const [questionData, setQuestionData] = React.useState(question || null);
	React.useEffect(() => {
		// setQuestionId(learner?.details?.state?.currentQuestion || []);
		if (
			learner?.details !== null &&
			(learner?.details?.answer || []).length === 0 &&
			!learner?.details?.state?.currentQuestion
		) {
			// redirect to main
			navigate(`${publicUrl}/${location?.search || ""}`);
		}

		// for initial reload, after fetching the learner information
		if (
			learner?.details?.state?.currentQuestion &&
			questionId.length === 0
		) {
			setQuestionId(learner?.details?.state?.currentQuestion);
		}
		getQData();
		return () => {};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [question, questionId, learner]);

	const getQData = async () => {
        const inQuestionPage = location.pathname === `${publicUrl}/question`; //location.pathname === '/question'

        if (learner?.showModuleBreak === true && inQuestionPage) {
			// redirect to module break page
			navigate(`${publicUrl}/continue${location?.search || ""}`);
        }
        if (learner?.showResumePage === true && inQuestionPage) {
			// redirect to module break page
			navigate(`${publicUrl}/resume${location?.search || ""}`);
        }
		setQuestionData(await getQuestionDetails(questionId));
	};

	return (
		<React.Fragment>
			{!learner?.showModuleBreak && loading && <LoadingIndicator />}
			{!learner?.showModuleBreak && (
				<QuestionRenderer
					question={{
						...question,
						questionData:
							Object.keys(questionData).length > 0
								? questionData
								: question.questionData,
					}}
					nextQuestion={(e) => setQuestionId(e)}
				/>
			)}
		</React.Fragment>
	);
}
